// extracted by css-extract-rspack-plugin
export default {"defaultIcon":"i52xfKpBloYPeBuw__defaultIcon___"};